import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
       <div class="banner-content">
      <h1 class="banner-title">Accuplacer Exam Prep 2024</h1>
      <p>
        The Mac App Store Products and App Store Products (collectively, “App
        Store Product(s)”) made available through the Mac App Store Service and
        App Store Service (collectively, “App Store Service(s)”) are licensed,
        not sold, to you. Your license to each App Store Product that you obtain
        through the App Store Services is subject to your prior acceptance of
        this Licensed Application End User License Agreement (“Standard EULA”),
        and you agree that the terms of this Standard EULA will apply to each
        App Store Product that you license through the App Store Service, unless
        that App Store Product is covered by a valid end user license agreement
        between you and the Application Provider of that App Store Product, in
        which case the terms of that separate end user license agreement will
        govern. Your license to any Apple Product under this Standard EULA or
        separate end user license agreement is granted by Apple, and your
        license to any Third-Party Product under this Standard EULA or separate
        end user license agreement is granted by the Application Provider of
        that Third-Party Product. Any App Store Product that is subject to the
        license granted under this Standard EULA is referred to herein as the
        “Licensed Application”. The Application Provider or Apple as applicable
        (“Licensor”) reserves all rights in and to the Licensed Application not
        expressly granted to you under this Standard EULA.
        <br /><br />
        a. Scope of License: This license granted to you for the Licensed
        Application by Licensor is limited to a nontransferable license to use
        the Licensed Application on any Apple-branded products running iOS
        (including but not limited to iPad, iPhone, and iPod touch) (“iOS
        Devices”) or Mac OS X (“Mac Computers”), as applicable (collectively,
        “Apple Device(s)”) that you own or control and as permitted by the usage
        rules set forth in the Mac App Store, App Store and iBooks Store Terms
        and Conditions (the “Usage Rules”). This license does not allow you to
        use the Licensed Application on any Apple Device that you do not own or
        control, and except as provided in the Usage Rules, you may not
        distribute or make the Licensed Application available over a network
        where it could be used by multiple devices at the same time. You may not
        rent, lease, lend, sell, transfer redistribute, or sublicense the
        Licensed Application and, if you sell your Mac Computer or iOS Device to
        a third party, you must remove the Licensed Application from the Mac
        Computer or iOS Device before doing so. You may not copy (except as
        expressly permitted by this license and the Usage Rules), decompile,
        reverse-engineer, disassemble, attempt to derive the source code of,
        modify, or create derivative works of the Licensed Application, any
        updates, or any part thereof (except as and only to the extent that any
        foregoing restriction is prohibited by applicable law or to the extent
        as may be permitted by the licensing terms governing use of any
        open-sourced components included with the Licensed Application). Any
        attempt to do so is a violation of the rights of the Licensor and its
        licensors. If you breach this restriction, you may be subject to
        prosecution and damages.
        <br /><br />
        The terms of this license will govern any upgrades provided by Licensor
        that replace and/or supplement the original Licensed Application, unless
        such upgrade is accompanied by a separate license in which case the
        terms of that license will govern.
        <br /><br />
        b. Consent to Use of Data: You agree that Licensor may collect and use
        technical data and related information—including but not limited to
        technical information about your device, system and application
        software, and peripherals—that is gathered periodically to facilitate
        the provision of software updates, product support, and other services
        to you (if any) related to the Licensed Application. Licensor may use
        this information, as long as it is in a form that does not personally
        identify you, to improve its products or to provide services or
        technologies to you.
        <br /><br />
        c. Termination. The license is effective until terminated by you or
        Licensor. Your rights under this license will terminate automatically
        without notice from the Licensor if you fail to comply with any term(s)
        of this license. Upon termination of the license, you shall cease all
        use of the Licensed Application and destroy all copies, full or partial,
        of the Licensed Application.
        <br /><br />
        d. External Services; Third-Party Materials. The Licensed Application
        may enable access to Licensor's and/or third-party services and websites
        (collectively and individually, “External Services”). Use of the
        External Services requires Internet access and use of certain External
        Services requires you to accept additional terms. By using this software
        in connection with an iTunes Store account, you agree to the latest
        iTunes Store Terms and Conditions and Usage Rules, which you may access
        and review at http://www.apple.com/legal/internet-services/itunes/ww/.
        <br /><br />
        You understand that by using any of the External Services, you may
        encounter content that may be deemed offensive, indecent, or
        objectionable, which content may or may not be identified as having
        explicit language, and that the results of any search or entering of a
        particular URL may automatically and unintentionally generate links or
        references to objectionable material. Nevertheless, you agree to use the
        External Services at your sole risk and that neither the Licensor nor
        its agents shall have any liability to you for content that may be found
        to be offensive, indecent, or objectionable.
        <br /><br />
        Certain External Services may display, include or make available
        content, data, information, applications or materials from third parties
        (“Third Party Materials”) or provide links to certain third party web
        sites. By using the External Services, you acknowledge and agree that
        neither the Licensor nor its agents is responsible for examining or
        evaluating the content, accuracy, completeness, timeliness, validity,
        copyright compliance, legality, decency, quality or any other aspect of
        such Third Party Materials or web sites. Neither the Licensor nor its
        agents warrant or endorse and does not assume and will not have any
        liability or responsibility to you or any other person for any
        third-party services, Third Party Materials or web sites, or for any
        other materials, products, or services of third parties. Third Party
        Materials and links to other web sites are provided solely as a
        convenience to you.
        <br /><br />
        Financial information displayed by any External Services is for general
        informational purposes only and should not be relied upon as investment
        advice. Before executing any securities transaction based upon
        information obtained through the External Services, you should consult
        with a financial or securities professional who is legally qualified to
        give financial or securities advice in your country or region. Location
        data provided by any External Services is for basic navigational
        purposes only and is not intended to be relied upon in situations where
        precise location information is needed or where erroneous, inaccurate,
        time-delayed or incomplete location data may lead to death, personal
        injury, property or environmental damage. Neither the Licensor, nor its
        agents, nor any of its content providers guarantees the availability,
        accuracy, completeness, reliability, or timeliness of stock information,
        location data or any other data displayed by any External Services.
        <br /><br />
        You agree that the External Services contain proprietary content,
        information and material that is owned by Licensor and/or its agents or
        licensors, and is protected by applicable intellectual property and
        other laws, including but not limited to copyright, and that you will
        not use such proprietary content, information or materials in any way
        whatsoever except for permitted use of the External Services or in any
        manner that is inconsistent with the terms of this Standard EULA or that
        infringes any intellectual property rights of a third party or Apple. No
        portion of the External Services may be reproduced in any form or by any
        means. You agree not to modify, rent, lease, loan, sell, distribute, or
        create derivative works based on the External Services, in any manner,
        and you shall not exploit the External Services in any unauthorized way
        whatsoever, including but not limited to, using the External Services to
        transmit any computer viruses, worms, trojan horses or other malware, or
        by trespass or burdening network capacity. You further agree not to use
        the External Services in any manner to harass, abuse, stalk, threaten,
        defame or otherwise infringe or violate the rights of any other party,
        and that neither Licensor nor its agents is in any way responsible for
        any such use by you, nor for any harassing, threatening, defamatory,
        offensive, infringing or illegal messages or transmissions that you may
        receive as a result of using any of the External Services.
        <br /><br />
        In addition, External Services and Third Party Materials that may be
        accessed from, displayed on or linked to from the Apple Devices are not
        available in all languages or in all countries or regions. Licensor
        makes no representation that such External Services and Materials are
        appropriate or available for use in any particular location. To the
        extent you choose to use or access such External Services and Materials,
        you do so at your own initiative and are responsible for compliance with
        any applicable laws, including but not limited to applicable local laws.
        Licensor and its licensors reserve the right to change, suspend, remove,
        or disable access to any External Services at any time without notice.
        In no event will Licensor be liable for the removal of or disabling of
        access to any such External Services. Licensor may also impose limits on
        the use of or access to certain External Services, in any case and
        without notice or liability.
        <br /><br />
        e. NO WARRANTY: YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE
        LICENSED APPLICATION IS AT YOUR SOLE RISK AND THAT THE ENTIRE RISK AS TO
        SATISFACTORY QUALITY, PERFORMANCE, ACCURACY AND EFFORT IS WITH YOU. TO
        THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE LICENSED APPLICATION
        AND ANY SERVICES PERFORMED OR PROVIDED BY THE LICENSED APPLICATION ARE
        PROVIDED “AS IS” AND “AS AVAILABLE”, WITH ALL FAULTS AND WITHOUT
        WARRANTY OF ANY KIND, AND LICENSOR HEREBY DISCLAIMS ALL WARRANTIES AND
        CONDITIONS WITH RESPECT TO THE LICENSED APPLICATION AND ANY SERVICES,
        EITHER EXPRESS, IMPLIED OR STATUTORY, INCLUDING, BUT NOT LIMITED TO, THE
        IMPLIED WARRANTIES AND/OR CONDITIONS OF MERCHANTABILITY, SATISFACTORY
        QUALITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY, QUIET ENJOYMENT,
        AND NON-INFRINGEMENT OF THIRD PARTY RIGHTS. LICENSOR DOES NOT WARRANT
        AGAINST INTERFERENCE WITH YOUR ENJOYMENT OF THE LICENSED APPLICATION,
        THAT THE FUNCTIONS CONTAINED IN OR SERVICES PERFORMED OR PROVIDED BY THE
        LICENSED APPLICATION WILL MEET YOUR REQUIREMENTS, THAT THE OPERATION OF
        THE LICENSED APPLICATION OR SERVICES WILL BE UNINTERRUPTED OR
        ERROR-FREE, OR THAT DEFECTS IN THE LICENSED APPLICATION OR SERVICES WILL
        BE CORRECTED. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY LICENSOR
        OR ITS AUTHORIZED REPRESENTATIVE SHALL CREATE A WARRANTY. SHOULD THE
        LICENSED APPLICATION OR SERVICES PROVE DEFECTIVE, YOU ASSUME THE ENTIRE
        COST OF ALL NECESSARY SERVICING, REPAIR OR CORRECTION. SOME
        JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR
        LIMITATIONS ON APPLICABLE STATUTORY RIGHTS OF A CONSUMER, SO THE ABOVE
        EXCLUSION AND LIMITATIONS MAY NOT APPLY TO YOU.
        <br /><br />
        f. Limitation of Liability. TO THE EXTENT NOT PROHIBITED BY LAW, IN NO
        EVENT SHALL LICENSOR BE LIABLE FOR PERSONAL INJURY OR ANY INCIDENTAL,
        SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES WHATSOEVER, INCLUDING,
        WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, CORRUPTION OR LOSS OF
        DATA, FAILURE TO TRANSMIT OR RECEIVE ANY DATA, BUSINESS INTERRUPTION OR
        ANY OTHER COMMERCIAL DAMAGES OR LOSSES, ARISING OUT OF OR RELATED TO
        YOUR USE OF OR INABILITY TO USE THE LICENSED APPLICATION OR ANY THIRD
        PARTY SOFTWARE OR APPLICATIONS IN CONJUNCTION WITH THE LICENSED
        APPLICATION, HOWEVER CAUSED, REGARDLESS OF THE THEORY OF LIABILITY
        (CONTRACT, TORT OR OTHERWISE) AND EVEN IF LICENSOR HAS BEEN ADVISED OF
        THE POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT ALLOW THE
        LIMITATION OF LIABILITY FOR PERSONAL INJURY, OR OF INCIDENTAL OR
        CONSEQUENTIAL DAMAGES, SO THIS LIMITATION MAY NOT APPLY TO YOU. In no
        event shall Licensor's total liability to you for all damages (other
        than as may be required by applicable law in cases involving personal
        injury) exceed the amount of fifty dollars ($50.00). The foregoing
        limitations will apply even if the above stated remedy fails of its
        essential purpose.
        <br /><br />
        g. You may not use or otherwise export or re-export the Licensed
        Application except as authorized by United States law and the laws of
        the jurisdiction(s) in which the Licensed Application was obtained. In
        particular, but without limitation, the Licensed Application may not be
        exported or re-exported (a) into any U.S. embargoed countries or (b) to
        anyone on the U.S. Treasury Department's list of Specially Designated
        Nationals or the U.S. Department of Commerce Denied Person's List or
        Entity List. By using the Licensed Application, you represent and
        warrant that you are not located in any such country or on any such
        list. You also agree that you will not use these products for any
        purposes prohibited by United States law, including, without limitation,
        the development, design, manufacture or production of missiles, nuclear,
        chemical or biological weapons.
        <br /><br />
        h. The Licensed Application and related documentation are “Commercial
        Items”, as that term is defined at 48 C.F.R. §2.101, consisting of
        “Commercial Computer Software” and “Commercial Computer Software
        Documentation”, as such terms are used in 48 C.F.R. §12.212 or 48 C.F.R.
        §227.7202, as applicable. Consistent with 48 C.F.R. §12.212 or 48 C.F.R.
        §§227.7202-1 through 227.7202-4, as applicable, the Commercial Computer
        Software and Commercial Computer Software Documentation are being
        licensed to U.S. Government end users (a) only as Commercial Items and
        (b) with only those rights as are granted to all other end users
        pursuant to the terms and conditions herein. Unpublished-rights reserved
        under the copyright laws of the United States.
        <br /><br />
        i. The laws of the State of California, excluding its conflicts of law
        rules, govern this license and your use of the Licensed Application.
        Your use of the Licensed Application may also be subject to other local,
        state, national, or international laws.
        <br /><br />
        Last updated: September 09, 2009
        <br /><br />
        © 2009 Apple Inc. All rights reserved.
      </p>
    </div>
    </div>
  );
}

export default App;
